module.exports = __webpack_public_path__ + "static/media/selectedTagIcon.7d97d1c6.svg";